import { render, staticRenderFns } from "./GenerateLinkPage.vue?vue&type=template&id=3bb1941e&scoped=true"
import script from "./GenerateLinkPage.vue?vue&type=script&lang=js"
export * from "./GenerateLinkPage.vue?vue&type=script&lang=js"
import style0 from "./GenerateLinkPage.vue?vue&type=style&index=0&id=3bb1941e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb1941e",
  null
  
)

export default component.exports